export default __webpack_public_path__ + "static/media/LAS0260.34I-31708_-17785_0.87172847.jpg";